/**
 * Gets a stringified error or if the stringified result is an empy string or empty object the default .toString() is used.
 * Created because JSON.stringify(error) will return {} for Error objects (https://stackoverflow.com/a/50738205/16998523).
 *
 * @param {unknown} error
 */
export function getErrorString(error: unknown): string {
	if (error instanceof Error && error.stack) {
		return error.stack;
	}

	const errorString = JSON.stringify(error);
	return errorString && errorString !== '{}' ? errorString : `${error as string}`;
}
